import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import SpinnerOverlay from 'base/components/SpinnerOverlay/SpinnerOverlay';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { closeModal } from 'modal/store/actions';
import SubmitButton from 'base/components/forms/SubmitButton';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import { DashboardIcon } from 'base/components/Icon';
import {
  Dashboard,
  getActiveDefaultDashboardIsLoading,
  getActiveDefaultDashboardToolboxWidgets,
  getAllWidgets,
  updateDefaultDashboard,
  setActiveDefaultDashboardCurrentBreakpoint,
} from '../../../../dashboard';

const NarrowWrapper = styled.div`
  width: 700px;
  margin: 0 auto;
`;


class EditDefaultDashboard extends React.Component {
  state = {
    layout: this.props.dashboard ? this.props.dashboard.layout : {}, // eslint-disable-line
  };

  onLayoutChange = (layout, layouts) => this.setState({ layout: layouts }); // eslint-disable-line

  onBreakpointChange = (breakpoint) => {
    const { setActiveDefaultDashboardCurrentBreakpoint } = this.props;
    setActiveDefaultDashboardCurrentBreakpoint(breakpoint);
  };


  render() {
    const {
      widgets, dashboard, toolboxWidgets, isLoading, onSubmit,
    } = this.props;
    return (
      <Formik
        initialValues={{
          name: dashboard && dashboard.name ? dashboard.name : '',
        }}
        validationSchema={
              Yup.object().shape({
                name: Yup.string()
                  .required('Name is required.'),
              })
            }
            render={({errors, isSubmitting}) => ( // eslint-disable-line
              <Form>
                <NarrowWrapper style={{ paddingBottom: '30px' }}>
                  <Field
                    type="text"
                    name="name"
                    placeholder="Name"
                    component={FormikInputField}
                    autoFocus
                  />
                  <FieldWrapper>
                    Note: to add a document to the default favorites, click on the
                    <br />
                    <DashboardIcon />
                    {' '}
icon next to a document in the file explorer.
                  </FieldWrapper>
                </NarrowWrapper>

                <div style={{ display: 'flex', position: 'relative', height: '100%' }}>
                  {isLoading && <SpinnerOverlay />}
                  {!isLoading && dashboard && (
                    <Dashboard
                      onBreakpointChange={this.onBreakpointChange}
                      widgets={widgets}
                      layouts={dashboard.layout}
                      toolboxWidgets={toolboxWidgets}
                      onLayoutChange={this.onLayoutChange}
                      isAdminMode
                      dashboardId={dashboard && dashboard.id ? dashboard.id : null}
                    />
                  )}
                </div>

                <NarrowWrapper style={{ padding: '50px' }}>
                  <SubmitButton type="submit" disabled={isSubmitting}>
                    Save default dashboard
                  </SubmitButton>
                </NarrowWrapper>
              </Form>
            )}
        onSubmit={(values) => {
          const { dashboard } = this.props;
          const { layout } = this.state;

          dashboard.layout = layout;
          dashboard.name = values.name;
          dashboard.isDefault = true;

          onSubmit(dashboard);
        }}
      />

    );
  }
}
EditDefaultDashboard.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired,
  widgets: PropTypes.arrayOf(PropTypes.any).isRequired,
  toolboxWidgets: PropTypes.arrayOf(PropTypes.any).isRequired, // eslint-disable-line
  isLoading: PropTypes.bool.isRequired, // eslint-disable-line
  fetchDashboard: PropTypes.func.isRequired, // eslint-disable-line
  updateDefaultDashboard: PropTypes.func.isRequired, // eslint-disable-line
  onSubmit: PropTypes.func.isRequired,
  setActiveDefaultDashboardCurrentBreakpoint: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  widgets: getAllWidgets(state),
  toolboxWidgets: getActiveDefaultDashboardToolboxWidgets(state),
  isLoading: getActiveDefaultDashboardIsLoading(state),
});

const mapDispatchToProps = {
  updateDefaultDashboard,
  closeModal,
  setActiveDefaultDashboardCurrentBreakpoint,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDefaultDashboard);
